import { isSameYear, isToday } from 'date-fns';

import { formatTimestamp } from 'modules/mobiCopilot/utils/functions';

import {
  DefaultMessage,
  GroupMessages,
} from 'modules/mobiCopilot/utils/interfaces';

export const groupMessagesByDay = (messages: DefaultMessage[]) => {
  const groupedMessages = {};

  const geTimestampLabel = (timestamp: number) => {
    const currentDate = new Date(timestamp);

    if (isToday(currentDate)) return 'Hoje';

    const date = new Date(timestamp);
    const today = new Date();

    const dateFormat = isSameYear(date, today)
      ? "EEE, dd 'de' MMMM"
      : "EEE, dd 'de' MMMM 'de' yyyy";

    return formatTimestamp({ timestamp, format: dateFormat });
  };

  messages.forEach(message => {
    const dateId = new Date(message.timestamp).toISOString().split('T')[0];

    if (!groupedMessages[dateId]) {
      groupedMessages[dateId] = {
        label: geTimestampLabel(message.timestamp),
        messages: [],
      };
    }

    groupedMessages[dateId].messages.push(message);
  });

  const currentMessages = Object.entries(groupedMessages).map(
    ([, value]) => value as GroupMessages
  );

  return currentMessages;
};

export const getUserName = (currentUserName: string) => {
  const name = currentUserName?.split(' ')?.[0] ?? '';
  const surname = currentUserName?.split(' ')?.[1] ?? '';

  const firstChar = name.charAt(0).toUpperCase();
  const lastChar = surname.charAt(0).toUpperCase();

  return {
    name,
    surname,
    initials: `${firstChar}${lastChar}`,
  };
};
